import axios from "axios"
import { handleResponse } from "."
import { BASE_URL } from "../utils/constant"

interface LoginResponse {
  access_token: string
}

// {"sub":"sy","username":"sy","iat":1736050890,"exp":1736050950}
interface ProfileResponse {
  sub: string
  username: string
  iat: number
  exp: number
}

const SERVICE_URL = `${BASE_URL}/auth`

export class AuthService {
  public static login = async (username: string, password: string): Promise<LoginResponse> => {
    return handleResponse<LoginResponse>(axios.post(`${SERVICE_URL}/login`, { username, password }))
  }

  public static getTokenHolding = async (tokenMintAddress: string, ownerIdentifier: string): Promise<ProfileResponse> => {
    return handleResponse<ProfileResponse>(
      axios.get(`${SERVICE_URL}/profile`, {
        params: { tokenMintAddress, ownerIdentifier },
      }),
    )
  }
}
